(function () {
  function replaceHeadingWithDiv(node) {
    return node;
  }

  function normalizeFieldBeyondCopy(root) {
    if (!root || window.location.pathname !== '/collections/field-beyond') return;

    var hero = document.querySelector('.varion-layout-collection-hero');
    if (hero) hero.style.display = 'none';

    var title = replaceHeadingWithDiv(root.querySelector('.varion-pod__title'));
    if (title) title.textContent = 'Poster und Tassen mit Airsoft-Motiven';

    var kicker = root.querySelector('.varion-pod__kicker');
    if (kicker) kicker.textContent = 'Field & Beyond';

    var lead = root.querySelector('.varion-pod__lead');
    if (lead) lead.textContent = 'Bildorientierte Motive für Schreibtisch, Werkstatt und Alltag.';

    var button = root.querySelector('.varion-pod__hero-button');
    if (button) button.textContent = 'Motive ansehen';
  }

  function initPodCollection(root) {
    if (!root || root.dataset.varionPodReady === 'true') return;
    root.dataset.varionPodReady = 'true';
    normalizeFieldBeyondCopy(root);

    var grid = root.querySelector('[data-varion-pod-grid]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-varion-pod-filter]'));
    var sort = root.querySelector('[data-varion-pod-sort]');

    function cards() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-varion-pod-card]'));
    }

    function applyFilter(filter) {
      cards().forEach(function (card) {
        var tags = (card.dataset.varionPodTags || '').split(/\s+/);
        card.hidden = filter !== 'all' && tags.indexOf(filter) === -1;
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (item) {
          item.classList.toggle('is-active', item === chip);
        });
        applyFilter(chip.dataset.varionPodFilter || 'all');
      });
    });

    if (sort && grid) {
      sort.addEventListener('change', function () {
        var value = sort.value;
        var sorted = cards().sort(function (a, b) {
          if (value === 'price-asc' || value === 'price-desc') {
            var diff = Number(a.dataset.varionPodPrice || 0) - Number(b.dataset.varionPodPrice || 0);
            return value === 'price-desc' ? diff * -1 : diff;
          }

          if (value === 'title-asc') {
            return (a.dataset.varionPodTitle || '').localeCompare(b.dataset.varionPodTitle || '', 'de');
          }

          return 0;
        });

        sorted.forEach(function (card) {
          grid.appendChild(card);
        });
      });
    }

    function applySizeChoice(sizeCard, sizeNode) {
      if (!sizeCard || !sizeNode) return;

      Array.prototype.slice.call(sizeCard.querySelectorAll('[data-varion-pod-size]')).forEach(function (item) {
        var active = item === sizeNode;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var priceNode = sizeCard.querySelector('[data-varion-pod-price]');
      var noteNode = sizeCard.querySelector('[data-varion-pod-format-note]');
      var linkNode = sizeCard.querySelector('[data-varion-pod-card-link]');
      var mediaNode = sizeCard.querySelector('.varion-pod-card__media');
      var addButton = sizeCard.querySelector('[data-varion-pod-atc]');
      var message = sizeCard.querySelector('[data-varion-pod-message]');

      sizeCard.classList.remove('is-size-missing');
      if (message) message.textContent = '';

      if (priceNode && sizeNode.dataset.sizePrice) {
        priceNode.textContent = sizeNode.dataset.sizePrice.replace(' EUR', ' \u20ac');
      }
      if (noteNode) {
        noteNode.textContent = 'Format: ' + (sizeNode.dataset.sizeLabel || 'Standard');
        if (sizeNode.dataset.sizeDimensions) {
          noteNode.textContent += ' - ' + sizeNode.dataset.sizeDimensions;
        }
      }
      if (linkNode && sizeNode.dataset.sizeUrl) linkNode.setAttribute('href', sizeNode.dataset.sizeUrl);
      if (mediaNode && sizeNode.dataset.sizeUrl) mediaNode.setAttribute('href', sizeNode.dataset.sizeUrl);
      if (addButton && sizeNode.dataset.sizeVariantId) addButton.dataset.variantId = sizeNode.dataset.sizeVariantId;
      if (addButton && !addButton.classList.contains('is-loading')) {
        var label = addButton.querySelector('span');
        if (label) label.textContent = addButton.dataset.varionPodLabel || 'In den Warenkorb';
      }
      if (sizeNode.dataset.sizePriceCents) sizeCard.dataset.varionPodPrice = sizeNode.dataset.sizePriceCents;
    }

    root.addEventListener('change', function (event) {
      var sizeSelect = event.target.closest('[data-varion-pod-size-select]');
      if (!sizeSelect) return;

      var sizeCard = sizeSelect.closest('[data-varion-pod-card]');
      var selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      applySizeChoice(sizeCard, selectedOption);
    });

    root.addEventListener('click', function (event) {
      var sizeButton = event.target.closest('[data-varion-pod-size]');
      if (sizeButton) {
        var sizeCard = sizeButton.closest('[data-varion-pod-card]');
        applySizeChoice(sizeCard, sizeButton);
        return;
      }

      var button = event.target.closest('[data-varion-pod-atc]');
      if (!button) return;

      var variantId = button.dataset.variantId;
      var card = button.closest('[data-varion-pod-card]');
      var message = card && card.querySelector('[data-varion-pod-message]');
      var label = button.querySelector('span');
      var sizeSelect = card && card.querySelector('[data-varion-pod-size-select]');

      if (sizeSelect && !sizeSelect.value) {
        card.classList.add('is-size-missing');
        if (message) message.textContent = 'Bitte zuerst die Gr\u00f6\u00dfe ausw\u00e4hlen.';
        sizeSelect.focus();
        return;
      }

      if (!variantId || !label) return;

      if (card) card.classList.remove('is-size-missing');
      button.disabled = true;
      button.classList.add('is-loading');
      label.textContent = 'Wird geladen';
      if (message) message.textContent = '';

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(function () {
          label.textContent = 'Im Warenkorb';
          if (message) message.textContent = 'Bereit im Warenkorb.';
          document.dispatchEvent(new CustomEvent('varion:cart:add'));
        })
        .catch(function () {
          label.textContent = 'Nochmal versuchen';
          if (message) message.textContent = 'Das hat gerade nicht geklappt.';
        })
        .finally(function () {
          button.disabled = false;
          button.classList.remove('is-loading');
          if (label.textContent === 'Wird geladen') {
            label.textContent = button.dataset.varionPodLabel || 'In den Warenkorb';
          }
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-varion-pod-collection]').forEach(initPodCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
